import React, { useState, useEffect } from 'react';

const ProjectCard = ({ project, onClick }) => {
  const [index, setIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    let interval;
    if (isHovered && project.images?.length > 1) {
      interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % project.images.length);
      }, 3000);
    } else {
      setIndex(0);
    }
    return () => clearInterval(interval);
  }, [isHovered, project.images]);

  return (
    <div onClick={onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}
      className="bg-white rounded-xl border shadow-sm p-4 cursor-pointer hover:shadow-xl transition-all">
      <div className="relative w-full h-48 overflow-hidden rounded-lg mb-4">
        {project.images?.map((img, i) => (
          <img key={i} src={img} alt={project.title}
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${i === index ? 'opacity-100' : 'opacity-0'}`} />
        ))}
      </div>
      <h3 className="text-xl font-bold">{project.title}</h3>
      <p className="text-gray-600 text-sm">{project.company_name}</p>
    </div>
  );
};

const ProjectModal = ({ project, onClose }) => {
  const [index, setIndex] = useState(0);
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white p-6 max-w-3xl w-full rounded-xl shadow-2xl relative" onClick={e => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-2xl font-bold">×</button>
        <div className="relative">
          <img src={project.images[index]} className="w-full h-96 object-cover rounded-lg" alt="Proyecto" />
          {project.images?.length > 1 && (
            <div className="flex justify-between mt-4">
              <button onClick={() => setIndex((prev) => (prev - 1 + project.images.length) % project.images.length)} className="bg-gray-800 text-white px-4 py-2 rounded">Anterior</button>
              <button onClick={() => setIndex((prev) => (prev + 1) % project.images.length)} className="bg-gray-800 text-white px-4 py-2 rounded">Siguiente</button>
            </div>
          )}
        </div>
        <h2 className="text-3xl font-bold mt-6">{project.title}</h2>
        <p className="text-gray-500 font-semibold">{project.company_name} - {project.category} ({project.date})</p>
        <p className="mt-4 text-gray-700">{project.description}</p>
      </div>
    </div>
  );
};

const PortfolioPage = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    fetch('https://voltaris-api.onrender.com/api/projects')
      .then(res => res.json())
      .then(data => setProjects(Array.isArray(data) ? data : []))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="pt-32 min-h-screen bg-gray-50 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold mb-10">Nuestro Portafolio</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {projects.map((p) => (
            <ProjectCard key={p.id} project={p} onClick={() => setSelectedProject(p)} />
          ))}
        </div>
      </div>
      {selectedProject && <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />}
    </div>
  );
};
export default PortfolioPage;